import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home'; // Assurez-vous de l'importation correcte du composant
import About from './pages/About';
import Education from './pages/Education';
import Work from './pages/Work';
import WorkDetails from './pages/WorkDetails';

function App() {
    return (
        <Router>
            <Header />
            <Routes>
                <Route path="/" element={<Home />} /> {/* Assurez-vous que Home est correctement importé */}
                <Route path="/about" element={<About />} />
                <Route path="/education" element={<Education />} />
                <Route path="/work" element={<Work />} />
                <Route path="/work/:id" element={<WorkDetails />} />
            </Routes>
            <Footer />
        </Router>
    );
}

export default App;
